// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m9ewfl{overflow-y:visible}
._1reoewfl{overflow-x:visible}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/smart-card/dist/esm/view/FlexibleCard/components/blocks/ai-summary-block/resolved/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,kBAAkB;AAC7B,WAAW,kBAAkB","sourcesContent":["._18m9ewfl{overflow-y:visible}\n._1reoewfl{overflow-x:visible}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
